import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { EventCardFragment } from "@generated-types"
import { Link } from "eddev/routing"

type Props = {
  event: EventCardFragment
}

export function EventCard(props: Props) {
  return (
    <div>
      <Link href={props.event.uri} className="flex flex-col gap-2">
        <ResponsiveImage {...props.event.info?.heroImage} />
        <div className="flex flex-col gap-1">
          <h3 className="type-title-m">{props.event.title}</h3>
          <div className="type-body-s">{props.event.info?.tessProductionSeason?.dateLabel}</div>
        </div>
      </Link>
      <div>
        <a
          href={
            import.meta.env.ED_PUBLIC_TNEW_ORIGIN +
            "/overview/" +
            props.event.info?.tessProductionSeason?.productionSeasonId
          }
        >
          TNEW
        </a>
      </div>
    </div>
  )
}
